import React from "react";
import classNames from "classnames";

const GenerateEntries = ({
  onClick,
  selectInRevitUrl,
  channel,
  entryGuids,
  generatingEntries,
  generatingEntriesFailed,
  generateEntriesError
}) => {
  
  const disabled = entryGuids.length === 0 || generatingEntries;

  return (
    <div className="generate-entries__wrapper">
      { generatingEntriesFailed ? (
        <p className="alert alert-danger text-center">
          { generateEntriesError }
        </p>
      ) : null}
      <button
        className={classNames(
          "btn btn-primary generate-entries__button",
          {
            disabled: disabled
          }
        )}
        onClick={ e => {
          e.preventDefault();
          if (!disabled) {
            onClick(selectInRevitUrl, channel, entryGuids)
          }
        }}
      >
        <strong>Generate entries</strong>
        { generatingEntries ? (<i className="fa fa-spinner fa-spin" />) : null}
      </button>
    </div>
  );    
}

export default GenerateEntries;